/**
 * 专区管理
 */
import request from "@/service";

export function getPartListByKey(params) {
  return request({
    url: `/resource/region/info/page`,
    method: "get",
    params
  });
}

export function partAdd(data) {
  return request({
    url: `/resource/region/info/save`,
    method: "post",
    data
  });
}

export function partEdit(data) {
  return request({
    url: `/resource/region/info/update`,
    method: "put",
    data
  });
}

export function partDelete (data) {
  return request({
    url: `/resource/region/info/delete`,
    method: "delete",
    data
  });
}

export function partUp (data) {
  return request({
    url: `/resource/region/info/online`,
    method: "put",
    params: data
  });
}


export function partDetail(uuid) {
  return request({
    url: `/resource/region/info/info/${uuid}`,
    method: "get"
  });
}

export function updatePartOrderByDrag(data) {
  return request({
    url: "/resource/region/info/orderByDrag",
    method: "put",
    data
  });
}
export function getPreview () {
  return request({
    url: 'resource/region/info/preview',
    method: 'put'
  })
}